import React from "react";
import { Button, Typography } from "@material-ui/core";
import GenericDialog from "../components/dialog/GenericDialog";
import { useActions } from "../actions";
import * as EnrolmentActions from "../actions/enrollment";
import * as PaymentActions from "../actions/payment";
import { ActionItems, UserUpdateRequestStatus } from "../constants";
interface AdminOverrideDialogProps {
    open: boolean;
    onClose: () => void;
    enrollmentId: string
    clientPolicyId: string
    refreshPage: Function
}

const ConfirmPaymentDetails: React.FC<AdminOverrideDialogProps> = ({ open, onClose, enrollmentId, clientPolicyId, refreshPage }) => {
    const enrollmentActions = useActions(EnrolmentActions);
    const payment = useActions(PaymentActions);
    const onConfirm = async () => {
        await enrollmentActions.sendEnrollmentDocsToCarrier({enrollmentId, step: 7})

        await payment.updateStatusAdminActionItemStatus({
            clientPolicyId: clientPolicyId,
            actionType: ActionItems.CONFIRM_PAYMENT_DETAILS.actionType,
            tag: UserUpdateRequestStatus.APPROVED
        });
        if (typeof refreshPage === "function") {
            refreshPage()
        }
        onClose()
    }

    return (
            <GenericDialog
                    open={open}
                    onClose={onClose}
                    title="Are the payment details for this policy correct?"
                    titleVariant="h6"
                    actions={
                        <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '16px', // spacing between buttons
                                    padding: '8px 0',
                                }}
                        >
                            <Button
                                    onClick={onConfirm}
                                    variant="contained"
                                    style={{ backgroundColor: '#d32f2f', color: '#fff' }} // Red Yes
                            >
                                Yes
                            </Button>
                            <Button
                                    onClick={onClose}
                                    variant="contained"
                                    color="primary" // Blue No
                            >
                                No
                            </Button>
                        </div>
                    }
                    fullWidth={true}
            >
            </GenericDialog>
    );
};


export default ConfirmPaymentDetails;